module.exports = __webpack_public_path__ + "static/img/13.b7f05b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carruDepto/13.jpg
// module id = +yg9
// module chunks = 5